import * as React from 'react';

import {TypeImplementation, withSystem, withMeta} from '@packages/systems/wfdl';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {TUnion, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {TEmail} from '@packages/systems/plugins/Email';
import {qualify, pluginName, typeName} from '@packages/systems/wfdl-Qualified';
import {LogicLabel} from '@packages/systems/flows/shared';
import {TNonEmptyText} from '@packages/systems/plugins/Text';

export const viewUsers = 'View users';
export const addUserId = 'Add user ID';
export const addUserEmail = 'Add user email';
export const selectAUser = 'Select a user';

const addUserIdType = withMeta(
  {placeholder: 'Enter user ID...'},
  withSystem({label: 'Add user ID', labelVariant: 'hidden'}, TNonEmptyText)
);
const addUserEmailType = withMeta(
  {placeholder: 'Enter user email...'},
  withSystem(
    {
      label: 'Add user email',
      labelVariant: 'hidden',
    },
    TEmail
  )
);
const viewAndSelectUserType = withSystem(
  {
    defaultValue: selectAUser,
    isFullWidth: true,
    bindUIVariant: 'custom',
    label: 'View users',
    labelVariant: 'hidden',
  },
  TTypeConstructor(
    qualify(pluginName('UsersPlugin'), typeName('UserSearchAliasType'))
  )
);

const typeOfUserIdentifierDropdown = withSystem(
  {
    isFullWidth: true,
    bindUIVariant: 'custom',
    label: 'User',
    labelVariant: 'hidden',
  },
  withMeta(
    {variant: 'menu', placeholder: 'Select a user'},
    TUnion({
      [viewUsers]: viewAndSelectUserType,
      [addUserId]: addUserIdType,
      [addUserEmail]: addUserEmailType,
    })
  )
);

/** The select dropdown with the option
 * - 'Enter used ID'
 * - 'Enter user email'
 * - 'Select a user'
 */
export const UserIdentifierDropdownType = TypeImplementation.Alias({
  type: typeOfUserIdentifierDropdown,
  system: {bindUIVariant: 'custom'},
  render: function RenderUserIdentifierDropdown({expr, dispatch}) {
    return (
      <>
        <LogicLabel label="User" required />
        <ExpressionEditor dispatch={dispatch} expression={expr} />{' '}
      </>
    );
  },
});
